import React from 'react';
import ListStudents from './List_Students';
import '../../../CommonCSS/SocietyCSS.css'

const ListStudApp = () => {
  return (

    <div className="app-wrapper">
      <div className="form-container">
        <div className='card' style={{borderRadius: '8px'}}>
          <div className="card-header-css" style={{borderRadius: '8px', textAlign: 'center' }} >
            <h5>Student Listings</h5>
          </div>
        </div>
        <ListStudents />
      </div>
    </div >
  );
};

export default ListStudApp;
